export const portfolioData = [
    {
        id: 1,
        img: '/images/samples/300x300/1.jpg',
        title: 'PHOTOGRAPHY',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 2,
        img: '/images/samples/300x300/2.jpg',
        title: 'LIFESTYLE',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 3,
        img: '/images/samples/300x300/3.jpg',
        title: 'TECH GEEKS',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 4,
        img: '/images/samples/300x300/4.jpg',
        title: 'EXPLORE WORLD',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 5,
        img: '/images/samples/300x300/5.jpg',
        title: 'TRAVEL',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 6,
        img: '/images/samples/300x300/6.jpg',
        title: 'WORLD',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 7,
        img: '/images/samples/300x300/7.jpg',
        title: 'CULTURES',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 8,
        img: '/images/samples/300x300/8.jpg',
        title: 'HABITS',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 9,
        img: '/images/samples/300x300/9.jpg',
        title: 'BEING YOURSELF',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 10,
        img: '/images/samples/300x300/10.jpg',
        title: 'NATURE',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 11,
        img: '/images/samples/300x300/11.jpg',
        title: 'ROUTINES',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 12,
        img: '/images/samples/300x300/12.jpg',
        title: 'LIFE',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 13,
        img: '/images/samples/300x300/13.jpg',
        title: 'VISION',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 14,
        img: '/images/samples/300x300/14.jpg',
        title: 'COLORS',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    {
        id: 15,
        img: '/images/samples/300x300/15.jpg',
        title: 'THROUGH NATURE',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
]